import { render, staticRenderFns } from "./NewUserInvitationView.vue?vue&type=template&id=3d998d5a&scoped=true&"
import script from "./NewUserInvitationView.vue?vue&type=script&lang=ts&"
export * from "./NewUserInvitationView.vue?vue&type=script&lang=ts&"
import style0 from "./NewUserInvitationView.vue?vue&type=style&index=0&id=3d998d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d998d5a",
  null
  
)

export default component.exports